import React from 'react';
import useIntls from '@opm/hooks/useIntls';
import { DefaultImg } from '@op/constants/defaultImg';
import TextBubbles from '@home/components/TextBubbles';
import './index.scss';
import { getAiSummaryText } from '../../utils';

interface ISummaryData {
  ai_summary: string;
  ai_summary_en: string;
}

interface IAISummaryBlockProps {
  /** 含 ai_summary / ai_summary_en 的数据对象，组件内部根据语言自动取值 */
  summaryData: ISummaryData | null;
  /** 是否展示标题行（AI icon + "AI Summary"），默认 true */
  hasTitle?: boolean;
  /** 是否展示边框（Details 页面需要），默认 false */
  hasBorder?: boolean;
  /** 文本区域最大行数（0 或不传 = 不截断；>0 使用 TextBubbles 截断） */
  maxLines?: number;
}

/**
 * AI Summary 公共渲染块
 *
 * 渐变面板内聚标题 + 文本，统一 Drawer / Card / Details 等视图的 AI 摘要 UI：
 *  - 可选标题行（AI icon + "AI Summary"），位于面板内部
 *  - 内部根据 isEn 自动从 summaryData 选取 ai_summary_en / ai_summary
 */
export default function AISummaryBlock({
  summaryData,
  hasTitle = true,
  hasBorder = false,
  maxLines,
}: IAISummaryBlockProps) {
  const { intl, isEn } = useIntls();

  const summary = React.useMemo(() => {
    if (!summaryData) return '';
    return getAiSummaryText(summaryData, isEn);
  }, [summaryData, isEn]);

  if (!summary) return null;

  return (
    <div className={`dbom-ct-ai-summary-block${hasBorder ? ' dbom-ct-ai-summary-block--border' : ''}`}>
      {hasTitle && (
        <div className="dbom-ct-ai-summary-block__header">
          <img
            src={DefaultImg.AI}
            alt=""
            className="dbom-ct-ai-summary-block__icon"
          />
          <span className="dbom-ct-ai-summary-block__title">
            {intl('AI Summary')}
          </span>
        </div>
      )}
      {maxLines ? (
        <TextBubbles
          className="dbom-ct-ai-summary-block__text"
          text={summary}
          rowNum={maxLines}
        />
      ) : (
        <div className="dbom-ct-ai-summary-block__text">{summary}</div>
      )}
    </div>
  );
}
